import React, { useId } from 'react';
import classnames from 'classnames';

const CrownIcon = (props) => {
  const { fill = '#D69500' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 12 12"
      preserveAspectRatio="none"
    >
      <path
        d="M11.0728 4.79486L9.46808 6.95843L8.76099 3.62635L7.3087 6.38137L6.09987 2.41309L4.89104 6.38137L3.43875 3.62635L2.73167 6.95843L1.12695 4.79486L2.03093 9.00371C3.36819 8.64006 4.73367 8.45862 6.09987 8.45862C7.46604 8.45862 8.83155 8.64006 10.1688 9.00371L11.0728 4.79486Z"
        fill={fill}
      />
      <path
        d="M6.09889 9.28768C7.42206 9.28768 8.74523 9.46029 10.0422 9.8032C10.079 9.63136 10.1149 9.46029 10.1516 9.28845C8.82001 8.92639 7.45945 8.745 6.09961 8.745C4.73977 8.745 3.37923 8.92639 2.04761 9.28845C2.0843 9.46029 2.12029 9.63136 2.15699 9.8032C3.45403 9.46029 4.77718 9.28768 6.10033 9.28768H6.09889Z"
        fill={fill}
      />
      <path
        d="M6.09819 2.16753C6.24358 2.16753 6.36142 2.03406 6.36142 1.86941C6.36142 1.70476 6.24358 1.57129 6.09819 1.57129C5.95285 1.57129 5.83496 1.70476 5.83496 1.86941C5.83496 2.03406 5.95285 2.16753 6.09819 2.16753Z"
        fill={fill}
      />
      <path
        d="M8.83569 3.38811C8.98109 3.38811 9.09893 3.25464 9.09893 3.08999C9.09893 2.92534 8.98109 2.79187 8.83569 2.79187C8.69035 2.79187 8.57251 2.92534 8.57251 3.08999C8.57251 3.25464 8.69035 3.38811 8.83569 3.38811Z"
        fill={fill}
      />
      <path
        d="M11.1871 4.695C11.3324 4.695 11.4503 4.56152 11.4503 4.39688C11.4503 4.23223 11.3324 4.09875 11.1871 4.09875C11.0417 4.09875 10.9238 4.23223 10.9238 4.39688C10.9238 4.56152 11.0417 4.695 11.1871 4.695Z"
        fill={fill}
      />
      <path
        d="M3.36063 3.38811C3.506 3.38811 3.62385 3.25464 3.62385 3.08999C3.62385 2.92534 3.506 2.79187 3.36063 2.79187C3.21526 2.79187 3.09741 2.92534 3.09741 3.08999C3.09741 3.25464 3.21526 3.38811 3.36063 3.38811Z"
        fill={fill}
      />
      <path
        d="M1.00956 4.695C1.15493 4.695 1.27277 4.56152 1.27277 4.39688C1.27277 4.23223 1.15493 4.09875 1.00956 4.09875C0.864183 4.09875 0.746338 4.23223 0.746338 4.39688C0.746338 4.56152 0.864183 4.695 1.00956 4.695Z"
        fill={fill}
      />
    </svg>
  );
};

const RankFrameIcon = (props) => {
  const {
    rank = 1,
    viewBox = '0 0 322 32',
    preserveAspectRatio = 'none',
  } = props;
  const uid = useId();
  const p0 = `${uid}-0`;
  const p1 = `${uid}-1`;
  const p2 = `${uid}-2`;
  const p3 = `${uid}-3`;
  const p4 = `${uid}-4`;
  const p5 = `${uid}-5`;
  const p6 = `${uid}-6`;
  const p7 = `${uid}-7`;

  const bgColor = rank === 1 ? '#C2A063' : rank == 2 ? '#8B8A8B' : '#BD7A56';
  const borderColor =
    rank === 1 ? '#FFFADD' : rank == 2 ? '#F5F5F5' : '#FFEEE0';
  const upStopColor =
    rank === 1 ? '#FEF8D2' : rank == 2 ? '#FDFDFD' : '#F9D8BF';
  const downStopColor =
    rank === 1 ? '#EAC786' : rank == 2 ? '#C5C5C5' : '#D6A383';

  return (
    <svg
      width="100%"
      height="100%"
      viewBox={viewBox}
      preserveAspectRatio={preserveAspectRatio}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0236596 23.0032C-0.0288897 20.9583 0.0224362 19.7899 0.0228784 17.7241L0.0239486 17.0103L0.0274002 12.9273L0.0280118 10.3329C0.0298387 7.76526 0.00691625 7.87256 1.64622 5.95349L3.36497 3.92403L5.10872 1.86236C5.32471 1.60628 5.55414 1.343 5.76373 1.08349C6.74903 -0.137954 8.07353 0.0063723 9.4827 0.00431543L12.6289 0.00259926L23.6596 0.00603159L305.056 0.00705483L310.74 0.00637267C311.789 0.0046586 312.861 -0.00733652 313.907 0.0149463C314.414 0.0389432 315.251 0.187378 315.649 0.548702C316.635 1.44379 317.52 2.64981 318.389 3.65733L320.336 5.90653C321.17 6.86743 321.777 7.33502 321.983 8.65622C322.011 9.30311 321.996 10.0456 321.996 10.6987L321.996 14.1152L321.997 16.9339L321.996 18.8406L321.995 22.1935C321.995 22.8559 322.009 22.515 321.977 23.1699C321.961 23.4928 321.898 23.8114 321.788 24.1149C321.713 24.3245 321.569 24.5717 321.428 24.7422C319.762 26.7518 318.054 28.7277 316.367 30.7197C316.129 30.9698 315.835 31.3554 315.533 31.5117C314.242 32.1779 312.222 31.9697 310.798 31.9676L305.533 31.9668L26.0449 31.9636L13.7281 31.9632L9.8959 31.9714C8.66152 31.9741 7.07771 32.1629 6.09553 31.2251C5.68366 30.8319 5.26295 30.2852 4.88917 29.8433L2.85064 27.4434L1.31179 25.6351C0.51066 24.6925 0.0862946 24.3269 0.0236596 23.0032Z"
        fill={bgColor}
      />
      <path
        d="M4.04416 21.2264C4.00828 20.6258 4.02548 20.9665 4.02555 20.3555L4.02317 12.172C4.02401 11.2189 3.8848 10.413 4.50947 9.62864C5.84821 7.94698 7.27966 6.3367 8.69253 4.71956C9.17236 4.17174 9.50674 3.68735 10.2758 3.63044C10.7703 3.59376 11.2666 3.60096 11.761 3.60062C23.8889 3.5925 298.987 3.50606 311.115 3.58862C311.449 3.62496 311.799 3.55777 312.069 3.79602C312.469 4.14912 312.806 4.57695 313.153 4.98626C314.509 6.59851 315.945 8.14621 317.246 9.80519C317.779 10.4854 317.598 11.6312 317.599 12.4287L317.603 20.5926C317.601 22.8798 317.775 21.5686 316.308 23.2867L313 27.153C311.732 28.6179 312.08 28.4109 310.172 28.407L33.9321 28.3731C26.1585 28.3858 18.3729 28.531 10.5995 28.3827C9.49188 28.3616 9.13849 27.7612 8.47044 26.985C7.41655 25.7604 6.34959 24.5476 5.3067 23.3131C4.69045 22.5851 4.2109 22.206 4.04416 21.2264Z"
        fill={borderColor}
      />
      <path
        d="M7.10718 0.549496C7.25524 0.419227 8.07732 0.411684 8.31547 0.411684C22.1628 0.408809 298.979 0.432066 312.826 0.417857C313.449 0.416828 314.144 0.390772 314.752 0.501501C313.927 1.44119 313.121 2.42663 312.229 3.30057C311.62 3.13842 310.661 3.17819 310.006 3.17853L13.4601 3.16996C10.6711 3.16996 10.2896 3.08106 9.64246 3.35474C8.71088 2.63137 7.80246 1.49097 7.10718 0.549496Z"
        fill={`url(#${p0})`}
      />
      <path
        d="M7.12817 31.4527C7.2022 31.2457 9.33645 28.8854 9.61625 28.5815C9.94218 28.7177 10.2285 28.7842 10.583 28.7891C11.5403 28.8025 12.5025 28.7974 13.4598 28.7973H18.8129L35.2112 28.8058L306.894 28.8074L309.449 28.8119C310.353 28.8139 311.38 28.8904 312.234 28.6443C312.582 29.0513 312.935 29.453 313.294 29.8493C313.746 30.3464 314.327 30.954 314.728 31.4779C314.082 31.5882 312.674 31.5575 311.993 31.5579L307.411 31.5582L28.3917 31.558L13.6778 31.5538L9.78781 31.5524C9.04653 31.5519 7.82758 31.5868 7.12817 31.4527Z"
        fill={`url(#${p1})`}
      />
      <path
        d="M317.949 10.3654L317.948 10.3393C317.985 10.2694 318.112 10.1672 318.18 10.1415C318.614 9.97626 321.292 8.29305 321.58 8.36984C321.646 8.62832 321.627 10.3012 321.627 10.6633L321.628 15.8219L321.628 21.5682C321.629 21.9233 321.668 23.3107 321.578 23.5747L321.522 23.5979C321.189 23.5222 318.398 21.9472 317.954 21.6878C318.016 20.9831 318.001 21.3467 318.001 20.6391L318 17.8205L317.998 16.9787V15.4256L317.999 12.5686C317.999 11.8127 318.015 11.1195 317.949 10.3654Z"
        fill={`url(#${p2})`}
      />
      <path
        d="M0.393473 22.742L0.395485 14.8202L0.396712 12.1767C0.396038 11.044 0.356568 9.51165 0.421862 8.41808C1.31543 8.9203 2.21719 9.40709 3.12674 9.87846C3.31477 9.97856 3.55245 10.1335 3.73856 10.247C3.60247 10.7777 3.63858 11.7043 3.63868 12.2874L3.63929 14.5884L3.63882 16.4661L3.64197 17.7223L3.64197 20.5104C3.6418 21.3012 3.61991 20.9585 3.71503 21.7455C2.61696 22.3551 1.51496 22.9573 0.409124 23.552C0.396032 23.2943 0.397768 23.0025 0.393473 22.742Z"
        fill={`url(#${p3})`}
      />
      <path
        d="M312.561 28.3854C312.567 28.3124 312.585 28.2613 312.633 28.2044C314.343 26.1649 316.167 24.1874 317.811 22.0938C318.598 22.536 319.415 22.954 320.205 23.3927C320.61 23.6178 321.004 23.7985 321.396 24.0539C321.308 24.2872 321.24 24.3784 321.092 24.5653C320.827 24.9007 320.491 25.2691 320.21 25.6006C319.524 26.4179 318.832 27.2286 318.132 28.0327C317.499 28.7697 315.868 30.849 315.19 31.2864C314.995 31.1252 314.35 30.4072 314.153 30.1802C313.686 29.6398 312.976 28.946 312.561 28.3854Z"
        fill={`url(#${p4})`}
      />
      <path
        d="M312.566 3.63359C312.576 3.50503 313.326 2.73028 313.472 2.56847L315.164 0.668598C315.848 1.11974 317.134 2.76216 317.75 3.48275L320.991 7.25678C321.176 7.47172 321.284 7.61673 321.398 7.87624C321.144 8.05862 320.377 8.46451 320.071 8.6318C319.372 9.01369 318.525 9.54197 317.811 9.86353L314.024 5.38159C313.605 4.88143 312.908 4.14952 312.566 3.63359Z"
        fill={`url(#${p5})`}
      />
      <path
        d="M0.544678 23.9931C0.672713 23.8468 3.53009 22.2885 3.86397 22.1534C4.72833 23.3186 5.89059 24.5994 6.83747 25.7072C7.52798 26.515 8.49021 27.72 9.25439 28.3969L8.79458 28.8987C8.13149 29.6014 7.37667 30.5679 6.70795 31.1985C6.19741 30.8894 5.5878 30.0656 5.1818 29.5857L3.41995 27.517L1.78213 25.5835C1.363 25.0879 0.85451 24.5509 0.544678 23.9931Z"
        fill={`url(#${p6})`}
      />
      <path
        d="M0.567627 7.98612C0.820837 7.42391 1.65849 6.54494 2.09027 6.03483L4.29414 3.43734C4.79871 2.84495 6.14021 1.10895 6.71942 0.755511C6.96246 0.982796 7.28457 1.38251 7.51437 1.64374C7.93811 2.12744 8.36928 2.60464 8.8078 3.0743L9.25922 3.55869C8.78744 3.93099 7.77717 5.16957 7.353 5.66356C6.16814 7.02899 4.99894 8.40847 3.84563 9.802C2.93983 9.37314 1.412 8.49999 0.567627 7.98612Z"
        fill={`url(#${p7})`}
      />
      <defs>
        <linearGradient
          id={p0}
          x1="160.93"
          y1="0.411435"
          x2="160.93"
          y2="3.35474"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={upStopColor} />
          <stop offset="1" stopColor={downStopColor} />
        </linearGradient>
        <linearGradient
          id={p1}
          x1="160.928"
          y1="28.5815"
          x2="160.928"
          y2="31.5615"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={upStopColor} />
          <stop offset="1" stopColor={downStopColor} />
        </linearGradient>
        <linearGradient
          id={p2}
          x1="319.792"
          y1="8.36729"
          x2="319.792"
          y2="23.5979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={upStopColor} />
          <stop offset="1" stopColor={downStopColor} />
        </linearGradient>
        <linearGradient
          id={p3}
          x1="2.06142"
          y1="8.41808"
          x2="2.06142"
          y2="23.552"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={upStopColor} />
          <stop offset="1" stopColor={downStopColor} />
        </linearGradient>
        <linearGradient
          id={p4}
          x1="316.978"
          y1="22.0938"
          x2="316.978"
          y2="31.2864"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={upStopColor} />
          <stop offset="1" stopColor={downStopColor} />
        </linearGradient>
        <linearGradient
          id={p5}
          x1="316.982"
          y1="0.668598"
          x2="316.982"
          y2="9.86353"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={upStopColor} />
          <stop offset="1" stopColor={downStopColor} />
        </linearGradient>
        <linearGradient
          id={p6}
          x1="4.89954"
          y1="22.1534"
          x2="4.89954"
          y2="31.1985"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={upStopColor} />
          <stop offset="1" stopColor={downStopColor} />
        </linearGradient>
        <linearGradient
          id={p7}
          x1="4.91342"
          y1="0.75551"
          x2="4.91342"
          y2="9.802"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={upStopColor} />
          <stop offset="1" stopColor={downStopColor} />
        </linearGradient>
      </defs>
    </svg>
  );
};

const NoRankFrameIcon = (props) => {
  const { viewBox, preserveAspectRatio } = props;
  return (
    <svg
      width="100%"
      height="100%"
      viewBox={viewBox}
      preserveAspectRatio={preserveAspectRatio}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0236596 23.0032C-0.0288897 20.9583 0.0224362 19.7899 0.0228784 17.7241L0.0239486 17.0103L0.0274002 12.9273L0.0280118 10.3329C0.0298387 7.76526 0.00691625 7.87256 1.64622 5.95349L3.36497 3.92403L5.10872 1.86236C5.32471 1.60628 5.55414 1.343 5.76373 1.08349C6.74903 -0.137954 8.07353 0.0063723 9.4827 0.00431543L12.6289 0.00259926L23.6596 0.00603159L305.056 0.00705483L310.74 0.00637267C311.789 0.0046586 312.861 -0.00733652 313.907 0.0149463C314.414 0.0389432 315.251 0.187378 315.649 0.548702C316.635 1.44379 317.52 2.64981 318.389 3.65733L320.336 5.90653C321.17 6.86743 321.777 7.33502 321.983 8.65622C322.011 9.30311 321.996 10.0456 321.996 10.6987L321.996 14.1152L321.997 16.9339L321.996 18.8406L321.995 22.1935C321.995 22.8559 322.009 22.515 321.977 23.1699C321.961 23.4928 321.898 23.8114 321.788 24.1149C321.713 24.3245 321.569 24.5717 321.428 24.7422C319.762 26.7518 318.054 28.7277 316.367 30.7197C316.129 30.9698 315.835 31.3554 315.533 31.5117C314.242 32.1779 312.222 31.9697 310.798 31.9676L305.533 31.9668L26.0449 31.9636L13.7281 31.9632L9.8959 31.9714C8.66152 31.9741 7.07771 32.1629 6.09553 31.2251C5.68366 30.8319 5.26295 30.2852 4.88917 29.8433L2.85064 27.4434L1.31179 25.6351C0.51066 24.6925 0.0862946 24.3269 0.0236596 23.0032Z"
        fill="black"
      />
      <path
        d="M4.04416 21.2264C4.00828 20.6258 4.02548 20.9665 4.02555 20.3555L4.02317 12.172C4.02401 11.2189 3.8848 10.413 4.50947 9.62864C5.84821 7.94698 7.27966 6.3367 8.69253 4.71956C9.17236 4.17174 9.50674 3.68735 10.2758 3.63044C10.7703 3.59376 11.2666 3.60096 11.761 3.60062C23.8889 3.5925 298.987 3.50606 311.115 3.58862C311.449 3.62496 311.799 3.55777 312.069 3.79602C312.469 4.14912 312.806 4.57695 313.153 4.98626C314.509 6.59851 315.945 8.14621 317.246 9.80519C317.779 10.4854 317.598 11.6312 317.599 12.4287L317.603 20.5926C317.601 22.8798 317.775 21.5686 316.308 23.2867L313 27.153C311.732 28.6179 312.08 28.4109 310.172 28.407L33.9321 28.3731C26.1585 28.3858 18.3729 28.531 10.5995 28.3827C9.49188 28.3616 9.13849 27.7612 8.47044 26.985C7.41655 25.7604 6.34959 24.5476 5.3067 23.3131C4.69045 22.5851 4.2109 22.206 4.04416 21.2264Z"
        fill="#FFF9FB"
      />
      <path
        d="M7.10718 0.549496C7.25524 0.419227 8.07732 0.411684 8.31547 0.411684C22.1628 0.408809 298.979 0.432066 312.826 0.417857C313.449 0.416828 314.144 0.390772 314.752 0.501501C313.927 1.44119 313.121 2.42663 312.229 3.30057C311.62 3.13842 310.661 3.17819 310.006 3.17853L13.4601 3.16996C10.6711 3.16996 10.2896 3.08106 9.64246 3.35474C8.71088 2.63137 7.80246 1.49097 7.10718 0.549496Z"
        fill="#FAE2E5"
      />
      <path
        d="M7.12817 31.4527C7.2022 31.2457 9.33645 28.8854 9.61625 28.5815C9.94218 28.7177 10.2285 28.7842 10.583 28.7891C11.5403 28.8025 12.5025 28.7974 13.4598 28.7973H18.8129L35.2112 28.8058L306.894 28.8074L309.449 28.8119C310.353 28.8139 311.38 28.8904 312.234 28.6443C312.582 29.0513 312.935 29.453 313.294 29.8493C313.746 30.3464 314.327 30.954 314.728 31.4779C314.082 31.5882 312.674 31.5575 311.993 31.5579L307.411 31.5582L28.3917 31.558L13.6778 31.5538L9.78781 31.5524C9.04653 31.5519 7.82758 31.5868 7.12817 31.4527Z"
        fill="#FAE2E5"
      />
      <path
        d="M317.949 10.3654L317.948 10.3393C317.985 10.2694 318.112 10.1672 318.18 10.1415C318.614 9.97626 321.292 8.29305 321.58 8.36984C321.646 8.62832 321.627 10.3012 321.627 10.6633L321.628 15.8219L321.628 21.5682C321.629 21.9233 321.668 23.3107 321.578 23.5747L321.522 23.5979C321.189 23.5222 318.398 21.9472 317.954 21.6878C318.016 20.9831 318.001 21.3467 318.001 20.6391L318 17.8205L317.998 16.9787V15.4256L317.999 12.5686C317.999 11.8127 318.015 11.1195 317.949 10.3654Z"
        fill="#FAE2E5"
      />
      <path
        d="M0.393473 22.742L0.395485 14.8202L0.396712 12.1767C0.396038 11.044 0.356568 9.51165 0.421862 8.41808C1.31543 8.9203 2.21719 9.40709 3.12674 9.87846C3.31477 9.97856 3.55245 10.1335 3.73856 10.247C3.60247 10.7777 3.63858 11.7043 3.63868 12.2874L3.63929 14.5884L3.63882 16.4661L3.64197 17.7223L3.64197 20.5104C3.6418 21.3012 3.61991 20.9585 3.71503 21.7455C2.61696 22.3551 1.51496 22.9573 0.409124 23.552C0.396032 23.2943 0.397768 23.0025 0.393473 22.742Z"
        fill="#FAE2E5"
      />
      <path
        d="M312.561 28.3854C312.567 28.3124 312.585 28.2613 312.633 28.2044C314.343 26.1649 316.167 24.1874 317.811 22.0938C318.598 22.536 319.415 22.954 320.205 23.3927C320.61 23.6178 321.004 23.7985 321.396 24.0539C321.308 24.2872 321.24 24.3784 321.092 24.5653C320.827 24.9007 320.491 25.2691 320.21 25.6006C319.524 26.4179 318.832 27.2286 318.132 28.0327C317.499 28.7697 315.868 30.849 315.19 31.2864C314.995 31.1252 314.35 30.4072 314.153 30.1802C313.686 29.6398 312.976 28.946 312.561 28.3854Z"
        fill="#FAE2E5"
      />
      <path
        d="M312.566 3.63359C312.576 3.50503 313.326 2.73028 313.472 2.56847L315.164 0.668598C315.848 1.11974 317.134 2.76216 317.75 3.48275L320.991 7.25678C321.176 7.47172 321.284 7.61673 321.398 7.87624C321.144 8.05862 320.377 8.46451 320.071 8.6318C319.372 9.01369 318.525 9.54197 317.811 9.86353L314.024 5.38159C313.605 4.88143 312.908 4.14952 312.566 3.63359Z"
        fill="#FAE2E5"
      />
      <path
        d="M0.544678 23.9931C0.672713 23.8468 3.53009 22.2885 3.86397 22.1534C4.72833 23.3186 5.89059 24.5994 6.83747 25.7072C7.52798 26.515 8.49021 27.72 9.25439 28.3969L8.79458 28.8987C8.13149 29.6014 7.37667 30.5679 6.70795 31.1985C6.19741 30.8894 5.5878 30.0656 5.1818 29.5857L3.41995 27.517L1.78213 25.5835C1.363 25.0879 0.85451 24.5509 0.544678 23.9931Z"
        fill="#FAE2E5"
      />
      <path
        d="M0.567627 7.98612C0.820837 7.42391 1.65849 6.54494 2.09027 6.03483L4.29414 3.43734C4.79871 2.84495 6.14021 1.10895 6.71942 0.755511C6.96246 0.982796 7.28457 1.38251 7.51437 1.64374C7.93811 2.12744 8.36928 2.60464 8.8078 3.0743L9.25922 3.55869C8.78744 3.93099 7.77717 5.16957 7.353 5.66356C6.16814 7.02899 4.99894 8.40847 3.84563 9.802C2.93983 9.37314 1.412 8.49999 0.567627 7.98612Z"
        fill="#FAE2E5"
      />
    </svg>
  );
};

const FrameIcon = (props) => {
  const { position = 'left', rank = 1 } = props;

  const viewBox =
    position === 'left'
      ? '0 0 12 32'
      : position === 'middle'
        ? '12 0 298 32'
        : '310 0 12 32';
  const preserveAspectRatio =
    position === 'left'
      ? 'xMinYMid meet'
      : position === 'middle'
        ? 'none'
        : 'xMaxYMid meet';

  if (rank > 3) {
    return (
      <NoRankFrameIcon
        viewBox={viewBox}
        preserveAspectRatio={preserveAspectRatio}
      />
    );
  } else {
    return (
      <RankFrameIcon
        rank={rank}
        viewBox={viewBox}
        preserveAspectRatio={preserveAspectRatio}
      />
    );
  }
};

const BeautyAwardBadge = (props) => {
  const {
    size = 'l',
    year = '2025',
    rank = 4,
    category = '',
    categoryKey = '',
  } = props;
  // const size = 'l'; // s, m, l
  // const rank = 2;
  const crownFill =
    rank === 1
      ? '#E29200'
      : rank == 2
        ? '#8B8A8B'
        : rank == 3
          ? '#C8764E'
          : '#FF6079';
  const textColor =
    rank === 1
      ? '#E29200'
      : rank == 2
        ? '#4A4A4A'
        : rank == 3
          ? '#C8764E'
          : '#FF6079';

  const crownSize = size === 's' ? 10 : size === 'm' ? 12 : 20;
  const textSize = size === 's' ? 9 : size === 'm' ? 11 : 16;
  const text =
    size === 'l'
      ? `${year}年Sorra年度票選大賞 ${category}第${rank}位`
      : `${year}年度大賞`;

  // const scale = size === 's' ? 18 / 32 : size === 'm' ? 24 / 32 : 1; // prototype

  const href =
    String(year) === '2025' && categoryKey
      ? `/beautyawards2025/result/ranking#${categoryKey}`
      : null;

  const content = (
    <div
      className={classnames(
        'relative flex origin-top-left items-center py-1',
        size === 's' ? 'px-1.5' : 'px-2',
        href && 'cursor-pointer'
      )}
    >
      <div className="absolute left-0 top-0 flex h-full w-full flex-row items-stretch justify-start">
        <div className="aspect-[12/32] h-full">
          <FrameIcon position="left" rank={rank} />
        </div>
        <div className="h-full grow">
          <FrameIcon position="middle" rank={rank} />
        </div>
        <div className="aspect-[12/32] h-full">
          <FrameIcon position="right" rank={rank} />
        </div>
      </div>

      <div className="relative flex flex-row items-center gap-x-0.5 text-base font-medium text-[##E29200]">
        <div
          style={{
            width: `${crownSize}px`,
          }}
          className="aspect-square"
        >
          <CrownIcon fill={crownFill} />
        </div>
        <p
          style={{
            color: textColor,
            fontSize: `${textSize}px`,
          }}
          className="font-medium leading-none"
        >
          {text}
        </p>
      </div>
    </div>
  );

  if (href) {
    return (
      <a href={href} onClick={(e) => e.stopPropagation()}>
        {content}
      </a>
    );
  }
  return content;
};

export default BeautyAwardBadge;
